// removed by extract-text-webpack-plugin
module.exports = {"keywordInput":"searchForm_keywordInput_147rV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/admin/index/searchForm.scss
// module id = 1520
// module chunks = 0